import commonUtils from "@/js/workspace/common_util.js";
import requestUtil from "@/js/request_util.js"

export default {

  // 主页打点
  home(that){
	 this.doPageviewRequest("/mc_project/home_page");
  },
  // share.multcloud.link域名访问打点
  sharePage(that){
    let url= window.location.href;
   this.doPageviewRequest(url);
  },
  // 数据视图1 游客绑定邮箱
  bindEmail(that, user){
    let category = this.getEdition(user) + "/" +  this.replaceLanguage(that.$i18n.locale);
    let event = "Activate/" + user.id + "/" + this.getDevice() + "/web/web/AOMEI";
    let label = "tour2mail";
    this.doEventRequest(category, event, label);
  },
  // 数据视图1 分享链接登录
  bindEmail(that, user){
    let category = this.getEdition(user) + "/" +  this.replaceLanguage(that.$i18n.locale);
    let event = "Activate/" + user.id + "/" + this.getDevice() + "/web/web/AOMEI";
    let label = "tour2mail";
    this.doEventRequest(category, event, label);
  },
  login(that, user){
	let label;
	let isTour = user.email.indexOf("@") == -1;
	if(isTour){
	  label = "oldtour";
	}else{
	  label = "oldmail";
	}
	let category = this.getEdition(user) + "/" + this.replaceLanguage(that.$i18n.locale);
	let event = "Login/" + user.id + "/" + this.getDevice() + "/web/AOMEI";
  this.doEventRequest(category, event, label);
  },
  // 数据视图3：付费转换1
  pay1(that, label) {
    let user = commonUtils.getUser();
    let category = this.getEdition(user) + "/" + this.replaceLanguage(that.$i18n.locale);
    let event = "Subscribe/" + user.id + "/" + this.getDevice() + "/web/AOMEI";
    this.doEventRequest(category, event, label);
  },
  // 数据视图4：付费转换2
  pay2(that, label) {
    let user = commonUtils.getUser();
    let email = user.email;
    let userType = email.indexOf("@") == -1 ? "tour" : "mail";
    let category = this.getEdition(user) + "/" + this.replaceLanguage(that.$i18n.locale) + "/" + userType;
    let event = "Upgrade/" + user.id + "/" + this.getDevice() + "/web/AOMEI";
    this.doEventRequest(category, event, label);
  },
  // 分享下载功能打点
  shareDownload(that) {
    let user = commonUtils.getUser();
    let category = this.getEdition(user) + "/" + this.replaceLanguage(that.$i18n.locale) + "/" + "share";
    let userId = user == null ? null : user.id;
    let event = "AOMEI/" + userId + "/" + this.getDevice() + "/download";
    let label = null;
    this.doEventRequest(category, event, label);
  },
  // 语言转换
  replaceLanguage(old){
    if(old == 'chinese'){
      return 'zh-CN';
    }
    if(old == 'deutsch'){
      return 'de-DE';
    }
    if(old == 'english'){
      return 'en-US';
    }
    if(old == 'france'){
      return 'fr-FR';
    }
    if(old == 'italian'){
      return ' it-IT';
    }
    if(old == 'japanese'){
      return 'ja-JP';
    }
    if(old == 'portuguese'){
      return 'pt-PT';
    }
    if(old == 'spanish'){
      return 'es-ES';
    }
    if(old == 'traditionalChinese'){
      return 'zh-TW';
    }
  },
  // 获取用户产品版本
  getEdition(user) {
    if(user){
      if (user.payType == null) {
        return "Free";
      }
      if(user.payType == "Monthly" && user.payLevel == 1){
        return "Monthly-un";
      }
      if(user.payType == "Yearly" && user.payLevel == 1){
        return "Yearly-un";
      }
      return user.payType;
    }else{
       return null;
    }
  },
  // 获取用户打开网站方式
  getClient() {
    // 使用浏览器打开：web；使用手机app打开：app；如果是通过桌面端程序打开，这里记为desktop
    return "web";
  },
  // 获取用户操作设备
  getDevice() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    let isPad = navigator.userAgent.match(/iPad/i);
    if (flag) {
      return "mobile"
    }
    if (isPad) {
      return "table"
    }
    return "pc";
  },
  // 开发部GA数据通过后端发送GA事件
  doEventRequest(category, action, label){
      var gaData = {
             action: action,
             category: category,
             label: label
           };
    requestUtil.doUserRequest("ga_send", gaData);
  },
  doPageviewRequest(html){
      var gaData = {html: html};
    requestUtil.doUserRequest("ga_pageview", gaData);
  }
};



// WEBPACK FOOTER //
// ./src/js/workspace/google_analytics_util.js